import { useQuery } from "@apollo/react-hooks";
import { QueryHookOptions } from "@apollo/react-hooks/lib/types";
import gql from "graphql-tag";

import { INPUT_PARAMETER_FRAGMENT } from "../../../../queries/common";

import { AllTasksData, AllTasksVariables, DEFAULT_TASK_ORDER } from "./AllTasks";

export const ALL_TASKS_QUERY = gql`
  query AllTasks(
    $orderBy: String
    $queueSlug: String
    $isAssignedTo: Boolean
    $isAssignedToUser: Boolean
    $isAssignedToUsersRole: Boolean
    $stateIdIn: [String]
    $isArchived: Boolean
    $search: String
    $after: String
    $before: String
    $first: Int
  ) {
    allTasks(
      orderBy: $orderBy
      queueSlug: $queueSlug
      isArchived: $isArchived
      isAssignedTo: $isAssignedTo
      isAssignedToUser: $isAssignedToUser
      isAssignedToUsersRole: $isAssignedToUsersRole
      stateIdIn: $stateIdIn
      search: $search
      after: $after
      before: $before
      first: $first
    ) {
      pollingCursor
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          transitionedAt
          title
          requester {
            id
            name
          }
          queue {
            id
            slug
            name
          }
          assignee {
            id
            type
            name
          }
          state {
            id
            name
            color
            fromTransitions {
              id
              name
              isPrimary
              functionId
              inputParameters {
                ...InputParameterFragment
              }
            }
          }
          fieldValues {
            name
            value
            type
          }
        }
      }
    }
  }
  ${INPUT_PARAMETER_FRAGMENT}
`;

export const useAllPollingTasks = (
  options?: QueryHookOptions<AllTasksData, Partial<AllTasksVariables>>
) => {
  const variables = options?.variables;
  return useQuery<AllTasksData, AllTasksVariables>(ALL_TASKS_QUERY, {
    ...options,
    variables: {
      ...variables,
      first: variables?.first ?? 50,
      orderBy: variables?.orderBy === undefined ? DEFAULT_TASK_ORDER : variables.orderBy
    }
  });
};
